/**
 * @fileoverview Reusable info section component for landing page
 * @author ISCRI Team
 */

import PropTypes from "prop-types";
import "./styles/InfoSection.css";

/**
 * Reusable info section component for different informational sections
 * @param {Object} props - Component props
 * @param {string} props.id - Section ID for navigation
 * @param {string} props.title - Section title
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Section content
 * @returns {JSX.Element} Info section component
 */
const InfoSection = ({ id, title, className = "", children }) => {
  return (
    <section id={id} className={`info-section ${className} reveal-element`}>
      <div className="container">
        <h2 className="section-title">{title}</h2>
        <div className="info-content">{children}</div>
      </div>
    </section>
  );
};

InfoSection.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default InfoSection;